import React from 'react';
import { ArrowIcon } from '@avila-tek/ui/src';
import { PageInfo } from '../../models';

interface PaginationProps {
  pageInfo: PageInfo;
  setPageInfo: React.Dispatch<React.SetStateAction<PageInfo>>;
  type: 'algolia' | 'pagination';
  scrollToTop?: boolean;
}

export default function Pagination({
  pageInfo,
  setPageInfo,
  type,
  scrollToTop = true,
}: PaginationProps) {
  const currentPage = React.useMemo(() => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(pageInfo.currentPage)) return 0;
    if (type === 'algolia') {
      return pageInfo.currentPage + 1;
    }
    return pageInfo.currentPage;
  }, [pageInfo]);

  const nextPage = (num: number) => {
    if (pageInfo.hasNextPage) {
      setPageInfo({ ...pageInfo, currentPage: pageInfo.currentPage + num });
      if (scrollToTop) window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const previousPage = (num: number) => {
    if (pageInfo.hasPreviousPage) {
      setPageInfo({ ...pageInfo, currentPage: pageInfo.currentPage - num });
      if (scrollToTop) window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const [numbers, setNumbers] = React.useState(<div />);

  React.useEffect(() => {
    setNumbers(
      <div className="inline-flex items-center text-gray-200">
        <p className="px-2 py-1 border-xs border-text-gray-300 text-purple-300 rounded-md cursor-pointer">
          {currentPage} de {pageInfo?.pageCount ? pageInfo?.pageCount : 0}
        </p>
      </div>
    );
  }, [
    pageInfo.currentPage,
    pageInfo.pageCount,
    pageInfo.hasNextPage,
    pageInfo.hasPreviousPage,
  ]);
  return (
    <div className="flex items-center justify-center py-6">
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          previousPage(1);
        }}
        className="relative inline-flex items-center mx-2 my-2"
        aria-label="Previous"
      >
        <ArrowIcon className="w-3 h-3 mr-2 text-neutral-700 hover:text-orange-500 rotate-180" />
      </button>

      {numbers}

      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          nextPage(1);
        }}
        className="relative inline-flex items-center mx-2 my-2"
        aria-label="Next"
      >
        <ArrowIcon className="w-3 h-3 ml-2 text-neutral-700 hover:text-orange-500 " />
      </button>
    </div>
  );
}
